import React, { useEffect, useState, useCallback } from "react";
import { AgGridReact } from "ag-grid-react";
import { themeQuartz } from "ag-grid-community";
import styles from "./styles.module.css";

const GridServerSide = ({
  columnDefs,
  fetchData, // função que chama sua API: (page, perPage) => Promise<{ rows, total }>
  paginationPageSize = 10,
}) => {
    const [nomePesquisa, setNomePesquisa] = useState("");
    const [gridApi, setGridApi] = useState(null);

    const localeTextBR = {
    contains: "Contém",
    notContains: "Não contém",
    equals: "Igual a",
    notEqual: "Diferente de",
    startsWith: "Começa com",
    endsWith: "Termina com",
    lessThan: "Menor que",
    greaterThan: "Maior que",
    lessThanOrEqual: "Menor ou igual a",
    greaterThanOrEqual: "Maior ou igual a",
    blank: "Vazio",
    notBlank: "Não vazio",
    andCondition: "E",
    orCondition: "Ou",
    sortAscending: "Ordenar crescente",
    sortDescending: "Ordenar decrescente",
    noSort: "Sem ordenação",
    page: "Página",
    more: "Mais",
    to: "até",
    of: "de",
    next: "Próximo",
    last: "Último",
    first: "Primeiro",
    previous: "Anterior",
    pageSize: "Tamanho da página",
    pageSizeSelectorLabel: "Tamanho da página",
    filterOoo: "Filtrar...",
    applyFilter: "Aplicar",
    resetFilter: "Redefinir",
    clearFilter: "Limpar",
    loadingOoo: "Carregando...",
    noRowsToShow: "Nenhum dado disponível",
    };

    const temaGrid = themeQuartz.withParams({
    backgroundColor: "#fff",
    foregroundColor: "#2B2B2B",
    headerTextColor: "#fff",
    headerBackgroundColor: "#1A3A5F",
    oddRowBackgroundColor: "rgba(0, 0, 0, 0.03)",
    headerColumnResizeHandleColor: "#1A3A5F",
    });

    const onGridReady = useCallback((params) => {
        setGridApi(params.api);
    }, []);

    useEffect(() => {

        if (!gridApi) return;
        if(nomePesquisa && nomePesquisa.length<3) return;
        
        const dataSource = {
            getRows: async (params) => {
                try {
                    gridApi.showLoadingOverlay();
                    const page = Math.floor(params.endRow / paginationPageSize);
                    const { rows, total } = await fetchData(page, paginationPageSize, nomePesquisa);
                    params.successCallback(rows, total);

                    if (rows && rows.length) {
                        gridApi.hideOverlay();
                    } else {
                        gridApi.showNoRowsOverlay();
                    }
                } catch (err) {
                    params.successCallback([], 0);
                }
            },
        };

        gridApi.setGridOption("datasource", dataSource);
        gridApi.refreshInfiniteCache(); // força refetch
        
    }, [fetchData, gridApi, paginationPageSize, nomePesquisa]);
 

    return (
        <div className={styles.containerListagem}>
            <input
                type="text"
                placeholder="Pesquisar por nome do candidato"
                className={styles.searchBar}
                onChange={(e)=>{setNomePesquisa(e.target.value)}}
            />
            <AgGridReact
                theme={temaGrid}
                localeText={localeTextBR}
                columnDefs={columnDefs}
                rowModelType="infinite"
                pagination={true}
                paginationPageSize={paginationPageSize}
                cacheBlockSize={paginationPageSize}
                onGridReady={onGridReady}
                overlayLoadingTemplate={
                    '<span class="ag-overlay-loading-center">Carregando...</span>'
                }
                overlayNoRowsTemplate={
                    '<span class="ag-overlay-no-rows-center">Nenhum dado disponível</span>'
                }
            />
        </div>
    );
};

export default GridServerSide;
